import React, { useEffect, useState, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import './OfficesPage.scss'
import officesService from './services/OfficesService';
import Section from '../../components/layout/Section';
import ErrorContent from '../../components/error/ErrorContent';
import OfficesPageHeader from './components/OfficesPageHeader';
import OfficesPageSummary from './components/OfficesPageSummary';
import EmployeesQueueTable from './components/EmployeesQueueTable';
import { jumpToTop } from '../../services/util/CommonUtil';

const OfficesPage = () => {

    const limit = 25;

    const { officeId } = useParams('officeId');

    const [summary, setSummary] = useState(null)
    const [employees, setEmployees] = useState(null)
    const [errorCode, setErrorCode] = useState(null)
    const [sortType, setSortType] = useState("FirstName")
    const [reversed, setReversed] = useState(false)
    const [offset, setOffset] = useState(0)
    localStorage.setItem('pageSelections', JSON.stringify([]));
    localStorage.setItem('reassignTicketIds', JSON.stringify([]));

    const getSummary = async () => {
        var summaryData = await officesService.getOfficeSummary(officeId)
        if (summaryData) {
            if (summaryData.error_code) {
                // handle the error
                setErrorCode(summaryData.error_code)
            } else {
                
                setSummary(summaryData);
            }
        }
    }

    const getEmployees = async () => {
        var employeeData = await officesService.getEmployees(officeId, offset, sortType, reversed)
        if (employeeData) {
            if (employeeData.error_code) {
                //handle the error
                setErrorCode(employeeData.error_code)
            }
            else {
                setEmployees(employeeData)
            }
        }
    }

    const getData = async () => {
        await Promise.all([getSummary()])
            .catch(err => {
                console.log(err)
            })       
    }

    const getEmployeeData = async () => {
        await Promise.all([getEmployees()])
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        setSummary(null)
        setOffset(0)
        getData();        
    }, [officeId])

    useEffect(() => {
        setEmployees(null)
        getEmployeeData();
    }, [sortType, offset, reversed])


    const handleSortChange = (sort, rev) => {
        if (sort !== sortType) {
            setSortType(sort)
            setOffset(0);
        }
        if (reversed !== rev) {
            setReversed(rev)
            setOffset(0);
        }
    }

    const handleOffsetChange = (offset) => {
        setOffset(offset)
        jumpToTop();
    }

    return (
        <div className="content-grid" >
            <Section sectionId='section-office-summary' className='white'>
                {!errorCode &&
                    <Fragment>
                        <OfficesPageHeader officeId={Number(officeId)} officeSummary={summary} />
                    </Fragment>
                }
                {(errorCode === 400 || errorCode === 404) &&
                    <ErrorContent errorDetailKey='OfficesPage.Errors.NoSuchOfficeDetail' errorTitleKey='OfficesPage.Errors.NoSuchOfficeTitle' />
                }
                {errorCode === 403 &&
                    <ErrorContent errorDetailKey='Errors.NotAllowedDetail' errorTitleKey='Errors.NotAllowedTitle' />
                }
            </Section>
            {!errorCode &&
                <Section sectionId='section-office' className='light-functional-grey'>
                    <OfficesPageSummary officeId={Number(officeId)} officeDetails={summary} />
                </Section>
            }
            {!errorCode &&
                <Section sectionId='section-queue' className='light-functional-grey pt-1'>
                <EmployeesQueueTable queue={employees} sort={sortType} onSortChanged={handleSortChange}
                        onSetOffset={handleOffsetChange} limit={limit} officeId={Number(officeId)} />
                </Section>
            }
        </div>
    );
}

OfficesPage.whyDidYouRender = false;

export default OfficesPage